module.exports = __webpack_public_path__ + "76d5776335a2183ea520d3d2007c7f3a.png";